import React from 'react';
import mainColors from '../../../../themes/main-colors';

type MapSearchIconProps = {
  size?: number;
  color?: string;
};

const MapSearchIcon: React.FC<MapSearchIconProps> = ({
  size = 30,
  color = mainColors.sparkBlue,
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 31 31"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.74759 28.1759C2.29731 28.3848 1.86565 28.3557 1.45259 28.0884C1.03954 27.8215 0.833008 27.434 0.833008 26.9259V5.11219C0.833008 4.78302 0.921203 4.48761 1.09759 4.22594C1.2737 3.96427 1.51523 3.77455 1.82217 3.65677L9.77967 0.898438L20.2476 4.55636L27.2518 1.80886C27.702 1.61136 28.1337 1.63538 28.5468 1.88094C28.9598 2.12622 29.1663 2.49747 29.1663 2.99469V16.6418C28.8877 16.2146 28.5752 15.8195 28.2288 15.4568C27.8825 15.0937 27.4969 14.7623 27.0722 14.4626V4.0501L21.2047 6.26385V12.8576C20.8316 12.8912 20.4733 12.9377 20.1297 12.9972C19.7858 13.0566 19.4462 13.1419 19.1109 13.253V6.26385L10.8884 3.43886V24.9976L2.74759 28.1759ZM2.92717 25.9239L8.79467 23.6889V3.43886L2.92717 5.40677V25.9239ZM21.8522 25.7414C22.9241 25.7414 23.8229 25.384 24.5484 24.6693C25.2737 23.9545 25.6393 23.0476 25.6451 21.9484C25.6506 20.8765 25.2879 19.9765 24.5568 19.2484C23.8256 18.5201 22.9241 18.1559 21.8522 18.1559C20.7802 18.1559 19.8801 18.5201 19.1518 19.2484C18.4237 19.9765 18.0597 20.8765 18.0597 21.9484C18.0597 23.0276 18.4237 23.9296 19.1518 24.6543C19.8801 25.379 20.7802 25.7414 21.8522 25.7414ZM21.8522 27.8351C20.2319 27.8351 18.8456 27.2591 17.6934 26.1072C16.5415 24.9552 15.9655 23.569 15.9655 21.9484C15.9655 20.3168 16.5415 18.9277 17.6934 17.7814C18.8456 16.635 20.2319 16.0618 21.8522 16.0618C23.4838 16.0618 24.8729 16.635 26.0193 17.7814C27.1656 18.9277 27.7388 20.3168 27.7388 21.9484C27.7388 22.584 27.6488 23.184 27.4688 23.7484C27.2886 24.3129 27.0256 24.8344 26.6801 25.313L30.833 29.4389L29.4538 30.8343L25.3118 26.7093C24.8218 27.0809 24.2898 27.3615 23.7159 27.5509C23.1423 27.7404 22.5211 27.8351 21.8522 27.8351Z"
        fill={color}
      />
    </svg>
  );
};

export default MapSearchIcon;
